<template>
  <RegionBasedAnnotationContainer :interactive="!isReadOnly" />
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, provide, watch } from 'vue';
import RegionBasedAnnotationContainer from '@/features/RegionBasedAnnotation/RegionBasedAnnotationContainer.vue';
import { useConfigStore } from '@/store';
import { useRBCSlideStore } from '@/store/modules/RBCregion';
import { useConstants, useApi } from '@/composables/useAppGlobals';
import { useRBC } from '@/features/RegionBasedAnnotation/useRBC';
import { reportReviewInjectionKey } from '@/views/components/reportReviewContext';

const config = useConfigStore();
const isReadOnly = computed(() => config.isReadOnly);
const slideStore = useRBCSlideStore();
const $const = useConstants();
const $api = useApi();

const reviewContext = useRBC();
provide(reportReviewInjectionKey, reviewContext);

const slideInfo = computed(() => config.slideInfo);

async function loadRBCImages(slideId: string) {
  try {
    const rawResponse = await $api.getRBCImages(slideId);
    if (!rawResponse) return;

    const schema = rawResponse.cells;
    Object.values(schema).forEach((image) => {
      if (image?.image_url && !image.image_url.startsWith('http')) {
        image.image_url = $api.getRBCImageUrl(image.image_url);
      }
    });
    slideStore.loadSchema(schema);
  } catch (error) {
    console.error('Failed to load RBC images', error);
  }
}

watch(
  () => slideInfo.value[$const.SLIDE_KEYS.SLIDE_ID] as string | number | undefined,
  (slideId) => {
    if (!slideId && slideId !== 0) {
      slideStore.reset();
      return;
    }
    slideStore.reset();
    void loadRBCImages(String(slideId));
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  slideStore.reset();
});
</script>
